import type { PathwayChain } from "../types";

export const ahtWtInitialSupplyChain: PathwayChain = {
  id: "aht-wt-initial-supply-chain",
  label: "AHT Weight Management — Initial Supply",
  service: "aht_private",
  selectionStep: {
    pathwayId: "weight-selection",
    label: "Drug selection",
  },
  drugInitialMap: {
    "tirzepatide": "aht-wt-tirzepatide-initial",
    "semaglutide": "aht-wt-semaglutide-initial",
    "oral_semaglutide": "aht-wt-oral-semaglutide-initial",
    "liraglutide": "aht-wt-liraglutide-initial",
    "mysimba":     "aht-wt-mysimba-initial",
    "orlistat":    "aht-wt-orlistat-initial",
  },
  missingMappingOutcome: "OUT_BLOCKED_MISSING_DRUG_MAPPING",
};
